import html2canvas, { Options } from "html2canvas";
import { useState } from "react";

export type ScreenshotType = {
    elementId: string;
    onError: (message: string) => void;
    options?: Partial<Options>;
    download?: boolean;
};

export const useScreenshot = (): {
    loading: boolean;
    getScreenshot: (input: ScreenshotType) => Promise<string | undefined>;
} => {
    const [loading, setLoading] = useState<boolean>(false);

    const getScreenshot = async (
        input: ScreenshotType
    ): Promise<string | undefined> => {
        const { elementId, onError, options, download = true } = input;

        const element = document.getElementById(elementId);

        if (!element) {
            onError(
                "An error ocurred while generating a screenshot: Element not found."
            );
            return;
        }

        setLoading(true);

        try {
            // 1. Screenshot element
            const canvas = await html2canvas(element, {
                useCORS: true,
                logging: true,
                ...options,
            });

            const image = canvas.toDataURL("image/png");

            // 2. Create download link
            if (download) {
                const currentDate = new Date();
                const timestamp = currentDate
                    .toISOString()
                    .replace(/:/g, "-")
                    .split(".")[0];

                const link = document.createElement("a");

                link.href = image;
                link.download = `Screenshot from ${timestamp}.png`;

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
            }

            return image;
        } catch (error) {
            onError(`An error ocurred while generating a screenshot: ${error}`);
        } finally {
            setLoading(false);
        }
    };

    return { loading, getScreenshot };
};
